import { createAction } from 'redux-actions';
export const setCountry = createAction('SET_COUNTRY');